"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TriangleBuilder = (props) => {
    const { primaryColor, secondaryColor, globalScaleFactor } = props;
    const dimension = 20 * globalScaleFactor; //TODO: ensure that web uses 20 and mobile uses 40 as a basis
    const shadowX = (1 / 20) * dimension;
    const shadowY = (1 / 15) * dimension;
    const margin = Math.max(shadowX, shadowY);
    const effectiveDimension = dimension - 2 * margin;
    const center = dimension / 2;
    const maxVal = center + effectiveDimension / 3;
    const minVal = center - effectiveDimension / 3;
    const baseline = center + effectiveDimension / 4;
    return `<svg
      width="${dimension}"
      height="${dimension}"
      view-box="0 0 ${dimension} ${dimension}"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <polygon
          points="${`${minVal},${baseline} ${center},${minVal} ${maxVal},${baseline} `}"
          fill="#${primaryColor}"
          stroke="${secondaryColor ? `#${secondaryColor}` : 'black'}"
        />
      </g>
    </svg>`;
};
exports.default = TriangleBuilder;
//# sourceMappingURL=TriangleBuilder.js.map